import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { useDispatch } from 'react-redux'
import { signOutUser } from '../../actions/authActions'
import Placeholder from './Placeholder'

const modalStyles = {
  content: {
    height: '460px',
    width: '30%',
    marginTop: '12%',
    overflow: 'hidden',
  },
}

const CommunityBlockModal = ({ showModal }) => {
  const dispatch = useDispatch()

  const signOut = useCallback(
    () => {
      dispatch(signOutUser())
    },
    [ dispatch ]
  )

  return (
    <Modal
      style={modalStyles}
      isOpen={showModal}
      contentLabel='Invite Family Modal'
    >
      <div className='modal-content animated fadeIn'>
        <div className='my-3'>
          <div className='col-12 mx-auto'>
            <Placeholder
              title={'You do not have Access'}
              icon={'fa-ban'}
              subtext1={
                'Your community is no longer using Operation 36 and you no longer have access.'
              }
              subtext2={'Please click the button to sign out of the app.'}
              buttonText={'Sign Out'}
              buttonIcon={'fa-sign-out'}
              handleClick={signOut}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

CommunityBlockModal.propTypes = {
  showModal: PropTypes.bool,
}

export default CommunityBlockModal
